import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { memo } from 'react';

import { getRequest } from '../../selectors/pageSelectors';
import { CheckDuplicatesPopupProps } from './CheckDuplicatesPopup.types';
import { NetSuitePopup, QBooksPopup, XeroPopup } from './components';

export const CheckDuplicatesPopup = memo<CheckDuplicatesPopupProps>((props) => {
    const { onSubmit, onCancel } = props;

    const request = useSelector(getRequest);

    switch (request.integrationCode) {
        case domain.IntegrationCode.QBooksBill:
            return <QBooksPopup onCancel={onCancel} onSubmit={onSubmit} />;
        case domain.IntegrationCode.XeroBill:
            return <XeroPopup onCancel={onCancel} onSubmit={onSubmit} />;
        case domain.IntegrationCode.NetSuiteBill:
            return <NetSuitePopup onCancel={onCancel} onSubmit={onSubmit} />;

        default:
            return null;
    }
});

CheckDuplicatesPopup.displayName = 'CheckDuplicatesPopupContent';
